import { createContext, Dispatch, SetStateAction } from 'react'

export interface ItemPageContextProps {
  busy: boolean
  setBusy: Dispatch<SetStateAction<boolean>>
  item: ItemPageJsonItem
  rules: Rule[]
  itemPageJson: ItemPageJson
  orderItem?: Item
  setItemPageJson: Dispatch<SetStateAction<ItemPageJson>>
  form: ItemForm
  setForm: Dispatch<SetStateAction<ItemForm>>
  hasFreeAvailable: (topping: ItemTopping) => boolean
  tiles: Tile[]
  tileModal: Tile | undefined
  setTileModal: Dispatch<SetStateAction<Tile | undefined>>
}

export const ItemPageContext = createContext<ItemPageContextProps>({} as ItemPageContextProps)
